import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

const VerifySuccess = () => {
  const navigate = useNavigate();
  const email = new URLSearchParams(window.location.search).get("email");

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <h2>✅ Email Verified Successfully!</h2>
      <p>{email && `Email: ${email}`}</p>
      <p>You can now log in to your account.</p>
      <Button variant="primary" onClick={() => navigate("/login")}>
        Go to Login
      </Button>
    </div>
  );
};

export default VerifySuccess;
